<template>
	<section class="achievement-page">
		<div>
			<h2 class="level-one-heading mb-5">{{ ta('TITLE') }}</h2>
			<hr>
			<div class="achievements-sub-header">
				<div>

				<div v-if="currentUser.id === user.id">{{ ta('SUB_TITLE') }}</div>
				<checkbox
					v-model="groupAchievements"
					small
					label="Gruppera achievements med flera nivåer"
				/>
				</div>
				<modal v-model="modalOpen">
					<button
						class="achievement-update-modal-button"
						slot="label"
						@click.prevent.stop="modalOpen = true"
						ariaLabel="Modal opener"
						type="button"
					>
						<img
							:src="convertToCdnUrl('/img/icons/reload.svg')"
							class="achievement-update-modal-button-icon"
							alt="Uppdatera achievements manuellt"
						/>
					</button>
      				<achievement-update-modal
					v-if="modalOpen === true"
					@close-modal="modalOpen = false"
					/>
      			</modal>
			</div>
		</div>
		<div :class="['list-settings', {'not-current-user': user.id !== currentUser.id,}]">
			<template v-if="currentUser.id === user.id">
				<toggle-button
					v-model="filters.unlocked"
					text="Unlocked"
					:counter="counts.unlocked"
				/>
				<toggle-button
					v-model="filters.inProgress"
					text="In progress"
					:counter="counts.inProgress"
				/>
				<toggle-button
					v-model="filters.locked"
					text="Locked"
					:counter="counts.locked"
				/>
			</template>
			<dropdown-select
				v-if="sortingOptions.length"
				v-model="sortingOption"
				:formatter="ta"
				:placeholder="0"
				prefix="SORT_BY"
				:items="sortingOptions"
			/>
		</div>
		<div class="clearfix mb-4" />
		<loading-spinner v-if="! achievements.length" />
		<div class="col-md-6 col-sm-6 p-2" v-for="achievement in sortedAchievements.slice(0, showCount)" :key="'achievement-' + achievement.id" @click="view(achievement)">
			<achievement :achievement="achievement" />
		</div>
		<div class="clearfix" />
		<auto-scroller class="mt-4" :viewportMargin="32" :loading="false" :trigger="increaseShowCount" v-if="showCount < sortedAchievements.length" />
		<modal v-model="isCurrentlyViewing">
			<achievement-modal :achievement="currentlyViewing"/>
		</modal>
	</section>
</template>

<script>
import waja from 'waja';
import store from 'datastore';
import { mapState } from 'vuex';
import { t } from 'datastore/i18n';
import { convertToCdnUrl } from 'utils';

export default {
	store,
	props: ['user'],
	data () {
		return {
			modalOpen: false,
			groupAchievements: false,
			achievements: [],
			counts: {},
			currentlyViewingId: null,
			filters: {
				locked: false,
				unlocked: true,
				inProgress: false,
			},
			showCount: 18,
			sortingOption: 'latest',
			sortingOptionsAvailable: [
				{
					value: 'progress',
					label: 'SORT.progress',
					filters: [
						'inProgress',
					],
				},
				{
					value: 'latest',
					label: 'SORT.latest',
					filters: [
						'inProgress',
						'unlocked',
					],
				},
				{
					value: 'name',
					label: 'SORT.name',
					filters: [
						'inProgress',
						'locked',
						'unlocked',
					],
				},
				{
					value: 'xp',
					label: 'SORT.xp',
					filters: [
						'inProgress',
						'locked',
						'unlocked',
					],
				},
				{
					value: 'rarity',
					label: 'SORT.rarity',
					filters: [
						'inProgress',
						'locked',
						'unlocked',
					],
				},
			],
		};
	},
	mounted () {
		this.loadAchievements();
		this.currentlyViewingId = this.$route.params.aid;
		window.addEventListener('keydown', this.boundKeyHandler);
	},
	beforeDestroy () {
		window.removeEventListener('keydown', this.boundKeyHandler);
	},
	methods: {
		convertToCdnUrl,
		keyHandler (e) {
			if (e.ctrlKey && e.keyCode === 70) {
				this.showCount = 9999;
			}
		},
		increaseShowCount () {
			this.showCount += 18;
			if (this.showCount > this.sortedAchievements.length) {
				this.showCount = this.sortedAchievements.length;
			}
			console.log(this.showCount);
		},
		tm: t.prefix('MEMBER'),
		ta: t.prefix('ACHIEVEMENT'),
		view (achievement) {
			this.currentlyViewingId = achievement.id;
		},
		loadAchievements () {
			this.achievements = [];
			const req = waja.get('user/' + this.$route.params.id + '/achievements');

			if (this.groupAchievements) {
				req.data({
					groupAchievements: 1,
				});
			}

			req.on('success', res => {
				this.achievements = res.data.achievements;
				this.counts = res.data.counts;
			}).go();
		},
		sortByLatest (a, b) {
			if (Math.max(a.achievedPercentage, b.achievedPercentage) === 1 && a.achievedPercentage !== b.achievedPercentage
				|| Math.min(a.achievedPercentage, b.achievedPercentage) === 0 && a.achievedPercentage !== b.achievedPercentage) {
				return b.achievedPercentage - a.achievedPercentage;
			}
			const points = b.modifiedAt - a.modifiedAt;
			if (points === 0) {
				return a.id - b.id;
			}
			return points;
		},
		sortByProgress (a, b) {
			if (a.achievedPercentage !== b.achievedPercentage) {
				return b.achievedPercentage - a.achievedPercentage;
			}
			const points = b.modifiedAt - a.modifiedAt;
			if (points === 0) {
				return a.id - b.id;
			}
			return points;
		},
		sortByRarity (a, b) {
			if (a.rarityOrder === b.rarityOrder && Math.max(a.achievedPercentage, b.achievedPercentage) === 1 && a.achievedPercentage !== b.achievedPercentage) {
				return b.achievedPercentage - a.achievedPercentage;
			}
			const points = b.rarityOrder - a.rarityOrder;
			if (points === 0) {
				const percent = b.achievedPercentage - a.achievedPercentage;
				if (percent === 0) {
					return a.id - b.id;
				}
				return percent;
			}
			return points;
		},
		sortByXP (a, b) {
			if (Math.max(a.achievedPercentage, b.achievedPercentage) === 1 && a.achievedPercentage !== b.achievedPercentage) {
				return b.achievedPercentage - a.achievedPercentage;
			}
			const points = b.experiencePoints - a.experiencePoints;
			if (points === 0) {
				return a.id - b.id;
			}
			return points;
		},
		sortByName (a, b) {
			return a.name.localeCompare(b.name);
		},
	},
	computed: {
		sortingOptions () {
			const sortingOptions = [];
			let first = null;
			for (const key in this.sortingOptionsAvailable) {
				const value = this.sortingOptionsAvailable[key];
				if (value.filters.indexOf('inProgress') > -1  && this.filters['inProgress'] === true
					|| value.filters.indexOf('locked') > -1  && this.filters['locked'] === true
					|| value.filters.indexOf('unlocked') > -1  && this.filters['unlocked'] === true) {
					if (! first) {
						first = value['value'];
					}
					if (value['value'] === this.sortingOption) {
						first = value['value'];
					}
					sortingOptions.push(value);
				}
			}
			return sortingOptions;
		},
		boundKeyHandler () {
			return this.keyHandler.bind(this);
		},
		currentlyViewing () {
			if (this.currentlyViewingId) {
				const aid = this.currentlyViewingId | 0;
				for (const ach of this.achievements) {
					if (ach.id === aid) {
						return ach;
					}
				}
			}
			return null;
		},
		achievementRarityExplanation () {
			const ach = this.currentlyViewing;
			if (! ach) {
				return;
			}
			const rarity = ach.rarityOrder;
			const pre = 'RARITY_';
			if (rarity === 6) {
				return this.ta(pre + 'EXCLUSIVE');
			} else if (rarity === 1) {
				return this.ta(pre + 'MORE_THAN_X', 40);
			}
			return this.ta(pre + 'LESS_THAN_X', [40, 15, 5, 1][rarity - 2]);
		},
		isCurrentlyViewing: {
			get () {
				return !! this.currentlyViewing;
			},
			set (val) {
				if (! val) {
					this.currentlyViewingId = null;
				}
			},
		},
		filteredAchievements () {
			return this.achievements.filter(this.filterFunction);
		},
		sortedAchievements () {
			return this.filteredAchievements.sort(this.sortFunction);
		},
		filterFunction () {
			return (ach) => {
				let status = 'locked';
				if (ach.achievedPercentage >= 1) {
					status = 'unlocked';
				} else if (ach.achievedPercentage > 0) {
					status = 'inProgress';
				}
				return this.filters[status];
			};
		},
		sortFunction () {
			switch (this.sortingOption) {
				case 'progress':
					return this.sortByProgress;
				case 'latest':
					return this.sortByLatest;
				case 'rarity':
					return this.sortByRarity;
				case 'xp':
					return this.sortByXP;
				case 'name':
					return this.sortByName;
				default:
					return this.sortByLatest;
			}
		},
		...mapState({
			currentUser: state => state.user,
		}),
	},
	watch: {
		$route (to, frm) {
			if (to.params.id !== frm.params.id) {
				this.loadAchievements();
			}
			this.currentlyViewingId = to.params.aid;
		},
		groupAchievements () {
			/* kanske lite dumt att ladda om listan flera gånger om kund klickar
			i och ur checkrutan, samtidigt tror jag inte att det kommer bli så vanligt
			att det blir ett problem så vi håller det enkelt.*/
			this.loadAchievements();
		},
		sortingOption () {
			this.showCount = 18;
		},
		filters: {
			handler () {
				this.sortingOption = this.sortingOptions[0];
				this.showCount = 18;
			},
			deep: true,
		},
	},
};
</script>
